import { spawn, takeEvery, all, take, put, call } from 'redux-saga/effects';
import { actions as usertaskUpdateActions } from 'modules/api/usertask/updateModule';
import { actions as usertaskListActions } from 'modules/api/usertask/listModule';
import toast from '@liquidweb-dev/undercurrent/toast';
import actions from './actions';

function* handleCancelSuccess({ uniq_id: uniqId }) {
	yield call(toast.success, 'Task successfully cancelled');

	yield put(usertaskListActions.clear());
	yield put(
		usertaskListActions.fetch({
			uniq_id: uniqId,
			status: 'pending',
			alsowith: ['action'],
		}),
	);
}

function* handleCancelSuccessScheduledTask() {
	yield call(toast.success, 'Task successfully cancelled');
	yield put(usertaskListActions.clear());
	yield put(
		usertaskListActions.fetch({
			alsowith: ['action', 'assetDetails'],
			order_by: { field: 'created_date' },
			page_size: 9999,
		}),
	);
}

function* handleCancelError() {
	yield call(
		toast.danger,
		'An error was encountered when cancelling a scheduled task.',
	);
}

function* handleCancelTask({ payload: { code, taskTable } }) {
	const [{ type, payload }] = yield all([
		take([usertaskUpdateActions.setType, usertaskUpdateActions.errorType]),
		put(
			usertaskUpdateActions.fetch({
				code,
				status: 'cancelled',
			}),
		),
	]);

	yield put(actions.cancelTaskRequestFinished(code));

	if (type === usertaskUpdateActions.setType) {
		if (taskTable) {
			return yield call(handleCancelSuccessScheduledTask, payload);
		}
		return yield call(handleCancelSuccess, payload);
	}

	return yield call(handleCancelError, payload);
}

function* watchCancelTask() {
	yield takeEvery(actions.USERTASK_CANCEL_TASK, handleCancelTask);
	yield takeEvery(actions.USERTASK_SCHEDULEDTASK_CANCEL_TASK, handleCancelTask);
}

export default function* userTaskSagas() {
	yield spawn(watchCancelTask);
}
